import dices from "assets/json/dicesNew.json"; // Feb 23rd, 2022
// import dices from "assets/json/dices_old.json";

const dicesData =
  window.loeweStrapTool && window.loeweStrapTool.dices
    ? window.loeweStrapTool.dices
    : dices;

var DICES_DATA = null;
var DICES_LIST = null;

class DicesService {
  static sortDices(dices) {
    dices.sort(function(a, b) {
      var nameA = a.size_type.toLowerCase(),
        nameB = b.size_type.toLowerCase();
      var sizeA = parseFloat(a.size.split(/[xX]+/)[1]),
        sizeB = parseFloat(b.size.split(/[xX]+/)[1]);
      if (nameA === "" && nameB !== "") return 1;
      if (nameB === "" && nameA !== "") return -1;
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      if (a.color < b.color) return -1;
      if (a.color > b.color) return 1;
      if (sizeA < sizeB) return 1;
      if (sizeA > sizeB) return -1;
      return 0;
    });
    return dices;
  }

  static getListOfDices() {
    if (!DICES_LIST) {
      this.getDices();
    }
    return DICES_LIST;
  }

  static formatDices(dices, mainCategory) {
    return dices.map(dice => {
      let images = [];
      if (Array.isArray(dice.images)) {
        images = dice.images.map(x => {
          return typeof x === "object" 
          ? Object.entries(x).map(([key, image]) => image).pop()
          : x
        })
      }
      return {
        ...dice,
        images,
        mainCategory
      }
    })
  }

  static setDicesToDiceList(dices) {
    !DICES_LIST && (DICES_LIST = []);
    DICES_LIST = DICES_LIST.concat(dices);
  }

  static getDices() {
    if (DICES_DATA) return DICES_DATA;
    DICES_DATA = Object.entries(dicesData).reduce((acum, [key, item]) => {
      const dices = this.formatDices(item, key);
      this.setDicesToDiceList(dices);
      acum.push({
        category: key,
        title: key,
        dices
      })
      return acum;
    }, []);
    return DICES_DATA;
  }

  static getDicesDic() {
    let dicResult = {};
    if (DICES_DATA) {
      DICES_DATA.forEach((section) => {
        section.dices.forEach((dice) => {
          dicResult[dice.id] = dice;
        })
      })
    } else {
      Object.entries(dicesData).forEach(([key, item]) => {
        const dices = this.formatDices(item, key);
        dices.forEach((dice) => {
          dicResult[dice.id] = dice;
        })
      })
    }

    return dicResult;
  }
}

export default DicesService;
